import React from 'react';
import { FileIcon } from '../ReactFileUtilities';
import { DownloadButton, FileSizeIndicator } from './components';
const UnMemoizedFileAttachment = ({ attachment }) => (React.createElement("div", { className: 'str-chat__message-attachment-file--item', "data-testid": 'attachment-file' },
    React.createElement(FileIcon, { className: 'str-chat__file-icon', mimeType: attachment.mime_type }),
    React.createElement("div", { className: 'str-chat__message-attachment-file--item-text' },
        React.createElement("div", { className: 'str-chat__message-attachment-file--item-first-row' },
            React.createElement("div", { className: 'str-chat__message-attachment-file--item-name', "data-testid": 'file-title' }, attachment.title),
            React.createElement(DownloadButton, { assetUrl: attachment.asset_url })),
        React.createElement(FileSizeIndicator, { fileSize: attachment.file_size }))));
export const FileAttachment = React.memo(UnMemoizedFileAttachment);
